<template>
    <div class="section3">
      
    </div>
  </template>
  
  <script>
  import "animate.css";
  import "hover.css";
  // import "magic.css";
  export default {
  };
  </script>
  
  <style lang="less" scoped>
  .section3 {
    background-image: url(../../assets/img/black-vip-bg-section3.png);
    background-size: cover;
    height: 100%;
    position: relative;
  }

  </style>
  